import { render } from "./ReactionModal.vue?vue&type=template&id=36b27fd0&scoped=true"
import script from "./ReactionModal.vue?vue&type=script&lang=js"
export * from "./ReactionModal.vue?vue&type=script&lang=js"

import "./ReactionModal.vue?vue&type=style&index=0&id=36b27fd0&scoped=true&lang=css"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b27fd0"]])

export default __exports__